export const skinCustom = {
  lightComponents: {
    body: '#ECEFF1',
    gradient: {
      gradientDefault1: '#36b348',
      gradientDefault2: '#82c02b',
    },
  },
  darkComponents: {
    body: '#263238',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#000000',
    },
  },
}

export const image = {
  principal: 'https://acialdigital.com.br/image-bank/LOGO_LUIZIANA.png',
  favicon: 'https://acialdigital.com.br/image-bank/LOGO_LUIZIANA_icone.png',
}

export const seo = {
  titulo: 'ACIAL - LUIZIANA',
  email: 'ti@senhadigital.com.br',
  palavrasChave:
    'Certificado Digital, Cnpj a1, Cpf a1, emitir certificado, certificado Luiziana',
  descricao:
    'Empresa líder em Certificação Digital, oferecendo soluções seguras e confiáveis para empresas e indivíduos, com ampla experiência no mercado.',
  descricaoPWA:
    'Certificados digitais são identidades eletrônicas seguras usadas para autenticar usuários, proteger informações e realizar transações online com segurança.',
}

export const header = {
  empresa: false,
  solucoes: false,
  contato: true,
  trabalheConosco: false,
  duvidasSuporte: true,
  parcerias: false,
  darkMode: false,
  contaLogin: true,
}

export const contentHome = {
  sispass: false,
  produtorRural: false,
  modalidadesCertificado: false,
}

export const footer = {
  is0800: false,
  telefone: ' ',
  whatsapp: '(44) 99998-3897',
  botaoRenocao: '44999983897',
  comercial: '44999983897',
  botaoWhatsapp: '44999983897',
  number0800: '0800 600 2710',
  cidadeuf: 'Luiziana/PR',
  cidade: 'Luiziana',
  bairro: 'Centro',
  titulo: 'Certificado Digital em Luiziana',
  rua: 'Rua Eugênio Alves da Rocha',
  numero: '74',
  complemento: '',
  cep: '87290-000',
  cnpj: '',
  messageContador: 'Olá, tenho interesse em ser Parceiro Indicador.',
  messageRevenda: 'Olá, tenho interesse em revender Certificados Digitais',
  messageAgendamento: 'Olá, gostaria de agendar a emissão do meu Certificado',
  messageRenovacao: 'Olá, gostaria de renovar meu Certificado Digital',
  messageRenovacaoSispass:
    'Olá, gostaria de renovar meu Certificado Digital Sispass',
  messageConhecaNossasSolucoes:
    'Olá, gostaria de conhecer as soluções da Senha Digital',
}

export const redes = {
  facebook: 'https://www.facebook.com/acialuiziana/?locale=pt_BR',
  instagram: 'https://www.instagram.com/acialluiziana/',
  linkedin: 'https://www.linkedin.com/company/senhadigitaloficial/mycompany/',
}

export const digisac = {
  id: 'df7a6a14-269a-46ba-a874-33c45e74badf',
  status: true,
}

export const ratings = [
  {
    id: 1,
    descricao: 'Suporte e Atendimento excelentes!',
    author: 'Leonardo Lopes',
    ratingvalue: 5,
  },
  {
    id: 2,
    descricao:
      'Atendimento excelente. Super ágil, prático e simplificado! Ótima organização da equipe.',
    author: 'Tháliton Morais',
    ratingvalue: 5,
  },
  {
    id: 3,
    descricao: 'Atendimento do Suporte Técnico nota 10!.',
    author: 'Felipe Mourão',
    ratingvalue: 5,
  },
]
